<button (click)="show()" class="btn btn-link text-light my-2 my-sm-0 py-0" type="button"
  [tooltip]="'onboarding.nav-tooltip' | translate ">
  <i class="fa fa-question-circle"></i>
</button>